<template>
    <b-dropdown toggle-class="flag bottom-menu-btn"
                menu-class="bottom-menu flag p-0 bg-white"
                variant="link"
                :offset="[10, 15]"
                left
                no-caret
                :aria-label="$t('language')"
                id="dropdown-language">
        <template #button-content>
            <img :src="`/src/assets/flags/${$i18n.locale}.svg`" height="20" :alt="$i18n.locale" loading="lazy" />

            <i class="ms-2 bi bi-chevron-down"></i>
        </template>

        <b-dropdown-text class="border-width-2">
            <b-button variant="link" @click="$root.changeLang('en')">
                <img src="/src/assets/flags/en.svg" height="20" alt="US" loading="lazy" />
            </b-button>
        </b-dropdown-text>

        <b-dropdown-text class="border-width-2">
            <b-button variant="link" @click="$root.changeLang('es')">
                <img src="/src/assets/flags/es.svg" height="20" alt="ES" loading="lazy" />
            </b-button>
        </b-dropdown-text>

        <b-dropdown-text class="border-width-2">
            <b-button variant="link" @click="$root.changeLang('fr')">
                <img src="/src/assets/flags/fr.svg" height="20" alt="FR" loading="lazy" />
            </b-button>
        </b-dropdown-text>
    </b-dropdown>
</template>

<script>
    export default {
        name: 'language-switcher'
    }
</script>